import {
  Box,
  Button,
  Center,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Link,
  Text,
  useToast,
} from "@chakra-ui/react";
import { MdLock, MdMailOutline } from "react-icons/md";
import { Link as ReactLink, useNavigate } from "react-router-dom";

import { useState } from "react";

import { useFormik } from "formik";
import routes from "../pages/routes";
import authService from "../services/auth.service";
import ForgotPasswordLayout from "./ForgotPasswordLayout";

function ForgotPassword() {
  const navigate = useNavigate();
  const toast = useToast();
  const [reset_password, PasswordStatus] = useState(false);
  const [newemail, setEmail] = useState("");
  //setEmail

  const formik = useFormik({
    initialValues: { email: "" },
    validate: (values: any) => {
      const errors: any = {};
      if (!values.email) {
        errors.email = "Email is required";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
      ) {
        errors.email = "Invalid email address";
      }
      return errors;
    },
    onSubmit: async (values) => {
      try {
        const response = await authService.forgot_password(values.email);
        setEmail(values.email);
        if (response) {
          PasswordStatus(true);

          toast({
            title: "Reset OTP sent to your email inbox",
            description: "",
            status: "success",
            duration: 3000,
          });
        }
      } catch (error: any) {
        toast({
          title: "Forgot Password",
          description: error.response.data.message,
          status: "error",
        });
      }
    },
  });
  const resetformik = useFormik({
    initialValues: { email: "", password: "", otp: "" },
    validate: (values: any) => {
      const errors: any = {};
      // if (!values.email) {
      //     errors.email = 'Email is required';
      // } else if (
      //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
      // ) {
      //     errors.email = 'Invalid email address';
      // }
      return errors;
    },
    onSubmit: async (values) => {
      const authData: any = {
        email: newemail,
        password: values?.password,
        otp: values?.otp,
      };
      try {
        const auth: any = await authService.confirmforgotPassword(authData);
        if ((auth.status = '"success"')) {
          navigate(routes.Login);
          toast({
            title: "Password Reset",
            description: "Password reset successful",
            status: "success",
          });
        } else {
          toast({
            title: "Password Reset",
            description: `${auth.message}`,
            status: "error",
          });
        }
      } catch (error: any) {
        toast({
          title: "Login",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    },
  });

  return (
    <ForgotPasswordLayout>
      <Box>
        <Text mb={14} fontSize={18} fontWeight="600" color="#616161">
          Forgot Password
        </Text>
        {!reset_password ? (
          <Box>
            <Text fontSize={12} color="#959595" mb={14}>
              Enter the email address linked to your account and we would send
              you a link to reset your password
            </Text>

            <form onSubmit={formik.handleSubmit}>
              <FormControl
                isInvalid={
                  formik.errors.email && formik.touched.email ? true : false
                }
                mb={14}
              >
                <FormLabel color="#959595" fontSize={12}>
                  EMAIL ADDRESS:
                </FormLabel>
                <InputGroup>
                  <InputLeftElement
                    color="#959595"
                    pointerEvents="none"
                    children={<MdMailOutline color="#959595" />}
                  />
                  <Input
                    type="email"
                    placeholder="alex@gmail.com"
                    name="email"
                    onChange={formik.handleChange}
                    fontSize={13}
                  />
                </InputGroup>
                <FormErrorMessage fontSize={12}>
                  {formik.errors.email}
                </FormErrorMessage>
              </FormControl>

              <Center>
                <Button
                  w="100%"
                  type="submit"
                  bg="#EC3337"
                  color="white"
                  mb={6}
                  fontSize={13}
                  isLoading={formik.isSubmitting}
                >
                  {" "}
                  Reset Password{" "}
                </Button>
              </Center>

              <Center>
                <Text color=" #9E9E9E" fontSize={12} alignSelf="center">
                  Have an account?{" "}
                  <Link as={ReactLink} to={routes.Login} color="#616161">
                    Login
                  </Link>{" "}
                </Text>
              </Center>
            </form>
          </Box>
        ) : (
          <Box>
            <Text fontSize={12} color="#959595" mb={14}>
              Enter the OTP sent to the email address linked to your account{" "}
            </Text>
            <form onSubmit={resetformik.handleSubmit}>
              <FormControl
                mb="27px"
                isInvalid={
                  resetformik.errors.email && resetformik.touched.email
                    ? true
                    : false
                }
              >
                <FormLabel color="#757575" fontSize={15}>
                  Email Address{" "}
                  <Text as="span" color="red">
                    *
                  </Text>
                </FormLabel>

                <Input
                  width="420px"
                  type="email"
                  id="email"
                  name="email"
                  value={newemail}
                  placeholder="alex@gmail.com"
                  onChange={resetformik.handleChange}
                  fontSize={14}
                />

                <FormErrorMessage fontSize={12}>
                  {resetformik.errors.email}
                </FormErrorMessage>
              </FormControl>
              <FormControl
                mb="27px"
                isInvalid={
                  resetformik.errors.otp && resetformik.touched.otp
                    ? true
                    : false
                }
              >
                <FormLabel color="#757575" fontSize={15}>
                  OTP{" "}
                  <Text as="span" color="red">
                    *
                  </Text>
                </FormLabel>

                <Input
                  width="420px"
                  type="otp"
                  id="otp"
                  name="otp"
                  placeholder="Enter OTP"
                  onChange={resetformik.handleChange}
                  fontSize={14}
                />

                <FormErrorMessage fontSize={12}>
                  {resetformik.errors.otp}
                </FormErrorMessage>
              </FormControl>

              <FormControl
                mb="27px"
                isInvalid={
                  resetformik.errors.password && resetformik.touched.password
                    ? true
                    : false
                }
              >
                <FormLabel color="brand.subtitle" fontSize={15}>
                  New Password{" "}
                  <Text as="span" color="red">
                    *
                  </Text>
                </FormLabel>
                <InputGroup>
                  <InputLeftElement
                    color="brand.subtitle"
                    pointerEvents="none"
                    children={<MdLock />}
                  />
                  <Input
                    width="420px"
                    type="password"
                    name="password"
                    id="password"
                    placeholder="Enter new password"
                    onChange={resetformik.handleChange}
                    fontSize={14}
                  />
                </InputGroup>
                <FormErrorMessage fontSize={12}>
                  {resetformik.errors.password}
                </FormErrorMessage>
              </FormControl>

              <Box>
                <Button
                  cursor="pointer"
                  w="100%"
                  bg="red"
                  color="white"
                  type="submit"
                  isLoading={resetformik.isSubmitting}
                  fontSize={14}
                >
                  RESET
                </Button>
              </Box>
            </form>
          </Box>
        )}
      </Box>
    </ForgotPasswordLayout>
  );
}

export default ForgotPassword;
